import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, Plus, Heart, User } from "lucide-react";
import { haptic } from "@/lib/utils";

export default function BottomNav() {
  const loc = useLocation();
  // Hide on auth pages
  if (["/login", "/register", "/auth/callback"].includes(loc.pathname)) return null;

  const items = [
    { to: "/", icon: Home, label: "Accueil", testid: "bnav-home" },
    { to: "/catalogue", icon: Search, label: "Recherche", testid: "bnav-search" },
    { to: "/vendre", icon: Plus, label: "Vendre", testid: "bnav-sell", primary: true },
    { to: "/favoris", icon: Heart, label: "Favoris", testid: "bnav-fav" },
    { to: "/dashboard", icon: User, label: "Profil", testid: "bnav-profile" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white hairline-t z-40">
      <div className="flex justify-around items-stretch h-[72px] pb-2">
        {items.map(({ to, icon: Icon, label, testid, primary }) => {
          const isActive = to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to);
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              onClick={() => haptic()}
              className="flex flex-col items-center justify-center flex-1 gap-1 tap-flash"
            >
              {primary ? (
                <div className={`w-12 h-12 -mt-4 flex items-center justify-center ${isActive ? 'bg-black text-[color:var(--color-mint)]' : 'bg-[color:var(--color-mint)] text-black'} border-2 border-black`}>
                  <Icon size={22} strokeWidth={2.5} />
                </div>
              ) : (
                <Icon size={22} strokeWidth={isActive ? 2.5 : 2} className={isActive ? 'text-black' : 'text-[color:var(--color-text-muted)]'} />
              )}
              <span className={`text-[10px] font-bold uppercase tracking-wider ${isActive ? 'text-black' : 'text-[color:var(--color-text-muted)]'}`}>{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
